export default __webpack_public_path__ + "static/icon-light-support-ee7c4618f37753281c5fccf2351ff0e5.webp";